var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resetButton"},[_c('ButtonLink',{staticClass:"text-small pb-4",attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }